import React from 'react';
import { Page as Component } from '~/components/specifics/deals/[id]/inspection_reports/Page';

export const Page: React.FC = () => <Component />;
